var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rounded-md bg-opacity-5 p-4 text-sm",class:[_vm.bgColor]},[_c('span',{staticClass:"bg-clip-text",class:[_vm.textColor, _vm.bgColor]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }